// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2GGfb","noInteraction":"EventWrapper_noInteraction__1kwuh"};